import React from 'react';

export const SelectYellowIcon: React.FC = () => {
  return (
    <svg width="15" height="8" viewBox="0 0 15 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 0.75L7.5 7.25L14 0.75" stroke="#FFB23F" strokeLinecap="round" />
    </svg>
  );
};
